import React, { useState, useMemo } from "react";
import { services } from "../services"; // adjust path

type ContactType = "email" | "phone" | null;

type InitPasswordRequest = {
  email?: string;
  mobileNumber?: string;
};

type InitPasswordResponse = {
  success: boolean;
  message?: string;
  password: string;
};

const GetPassword: React.FC = () => {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");

  const contactType: ContactType = useMemo(() => {
    if (!value) return null;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;

    if (emailRegex.test(value)) return "email";
    if (phoneRegex.test(value)) return "phone";

    return null;
  }, [value]);

  const handleSubmit = async () => {
    if (!contactType) {
      setError("Please enter a valid email or mobile number");
      return;
    }
    setLoading(true);

    const payload: InitPasswordRequest =
      contactType === "email" ? { email: value } : { mobileNumber: value };

    try {
      console.log("heheh");

      const response = await services.requestSvc.post<InitPasswordResponse>(
        "/init-password",
        payload
      );
      console.log("response", response);
      setPassword(response.password);

      if (!response?.success) {
        throw new Error(response?.message || "Request failed");
      }
    } catch (err: any) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mt-10 bg-white p-6 rounded-xl shadow">
      <h2 className="text-xl font-semibold mb-2">Get Initial Password</h2>

      <p className="text-sm text-gray-600 mb-4">
        Enter user's email address or mobile number.
      </p>

      <input
        type="text"
        placeholder="Email or Mobile Number"
        value={value}
        onChange={(e) => {
          setValue(e.target.value.trim());
          setError("");
          setSuccess("");
          setPassword("");
        }}
        className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <br />
      <br />
      {password && <p className="font-medium">{password}</p>}

      {error && <p className="text-sm text-red-600 mt-3">{error}</p>}

      {success && <p className="text-sm text-green-600 mt-3">{success}</p>}

      <button
        onClick={handleSubmit}
        disabled={!contactType || loading}
        className={`mt-4 w-full py-2 rounded-md text-white font-medium
          ${
            loading || !contactType
              ? "bg-gray-400 cursor-not-allowed"
              : "btn-primary"
          }`}
      >
        {loading ? "Sending..." : "Fecth Password"}
      </button>
    </div>
  );
};

export default GetPassword;
